const inFlight = new Map<string, Promise<unknown>>();
const recentResults = new Map<string, { data: unknown; ts: number }>();
const DEDUP_TTL_MS = 300;

export async function dedup<T>(key: string, fn: () => Promise<T>): Promise<T> {
  const cached = recentResults.get(key);
  if (cached && Date.now() - cached.ts < DEDUP_TTL_MS) {
    return cached.data as T;
  }

  const existing = inFlight.get(key);
  if (existing) return existing as Promise<T>;

  const promise = fn()
    .then((result) => {
      recentResults.set(key, { data: result, ts: Date.now() });
      return result;
    })
    .finally(() => inFlight.delete(key));
  inFlight.set(key, promise);
  return promise;
}

export function invalidateDedup(keyPrefix: string): void {
  for (const key of recentResults.keys()) {
    if (key.startsWith(keyPrefix)) {
      recentResults.delete(key);
    }
  }
}
